"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../constants");
var _valueMap = _interopRequireDefault(require("../utils/valueMap"));
var _polished = require("polished");
var _colors = require("../../birch/colors");
var _templateObject, _templateObject2, _templateObject3;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var VALID_SIZES = ['small', 'medium', 'large'];
var size = (0, _valueMap["default"])(VALID_SIZES, 'size');
var flavorStyles = function flavorStyles(flavor, themeName) {
  var flavorMapping = themeName !== _constants.ReskinThemes.BIRCH ? flavorStyles.styles : flavorStyles.birchStyles;
  return flavorMapping[flavor] || {};
};
flavorStyles.styles = {
  green: {
    foregroundColor: _constants.colors.mediumGreenhouseGreen,
    backgroundColor: (0, _polished.rgba)(0, 178, 169, 0.05)
  },
  doubleGreen: {
    foregroundColor: _constants.colors.mediumGreenhouseGreen,
    backgroundColor: _constants.colors.lightGreenhouseGreen
  },
  pale: {
    foregroundColor: _constants.colors.white,
    backgroundColor: (0, _polished.rgba)(255, 255, 255, 0.2)
  }
};
flavorStyles.birchStyles = {
  green: {
    foregroundColor: _colors.FullPalette.GREEN_700,
    backgroundColor: _colors.FullPalette.GREEN_E25
  },
  doubleGreen: {
    foregroundColor: _colors.FullPalette.GREEN_700,
    backgroundColor: _colors.FullPalette.GREEN_E25
  },
  pale: {
    foregroundColor: _colors.FullPalette.WHITE,
    backgroundColor: _colors.FullPalette.WHITE
  }
};

/*

Code taken from here: https://projects.lukehaas.me/css-loaders/
and adapted for styled-components

*/

var rotate = (0, _styledComponents.keyframes)(["0%{-webkit-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg);}"]);
var LoadingSpinner = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['size', 'flavor'].includes(prop);
  }
}).withConfig({
  displayName: "loading_spinner__LoadingSpinner"
})(["display:inline-block;", " ", " ", " position:relative;text-indent:-9999em;border-top:0.5em solid ", ";border-right:0.5em solid ", ";border-bottom:0.5em solid ", ";border-left:0.5em solid ", ";transform:translateZ(0);animation:", " 1.1s infinite linear;&,&:after{border-radius:50%;width:5em;height:5em;}"], size.small(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["font-size: 3px;"]))), size.medium(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["font-size: 6px;"]))), size.large(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["font-size: 20px;"]))), function (props) {
  var _props$theme;
  return flavorStyles(props.flavor, (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.name).backgroundColor;
}, function (props) {
  var _props$theme2;
  return flavorStyles(props.flavor, (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.name).backgroundColor;
}, function (props) {
  var _props$theme3;
  return flavorStyles(props.flavor, (_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.name).backgroundColor;
}, function (props) {
  var _props$theme4;
  return flavorStyles(props.flavor, (_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.name).foregroundColor;
}, rotate);
LoadingSpinner.displayName = 'LoadingSpinner';
LoadingSpinner.defaultProps = {
  size: 'large',
  flavor: 'green'
};
var ThemedLoadingSpinner = (0, _styledComponents.withTheme)(LoadingSpinner);
var _default = exports["default"] = ThemedLoadingSpinner;